import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["value"]

import type { SelectFormOption } from '@src/components/shared/form_fields/FormOptions';
import { useFieldModel } from '@src/components/shared/form_fields/useFieldModel';
import SelectFormInput from '@src/components/shared/form_elements/SelectFormInput.vue';
import { useAriaDescribedby } from '@src/components/shared/composables/useAriaDescribedby';
import { computed } from 'vue';
import FieldContainer from '@src/components/patterns/FieldContainer.vue';

interface Props {
	label: String;
	name: string;
	inputId: string;
	modelValue: string | number;
	options: SelectFormOption[];
	errorMessage?: String;
	showError?: boolean;
	isMaxWidthField?: boolean;
	ariaDescribedby?: string | undefined;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectField',
  props: {
    label: {},
    name: {},
    inputId: {},
    modelValue: {},
    options: {},
    errorMessage: {},
    showError: { type: Boolean },
    isMaxWidthField: { type: Boolean },
    ariaDescribedby: {}
  },
  emits: [ 'update:modelValue', 'field-changed' ],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;

const fieldModel = useFieldModel<string | number>( () => props.modelValue, props.modelValue );
const ariaDescribedby = useAriaDescribedby(
	props.inputId,
	computed<boolean>( () => false ),
	computed<boolean>( () => props.showError ),
	computed<boolean>( () => false ),
	computed<string | undefined>( () => props.ariaDescribedby )
);

const onFieldChange = ( newValue: string | number ): void => {
	emit( 'update:modelValue', newValue );
	emit( 'field-changed', props.name );
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FieldContainer, {
    "input-id": __props.inputId,
    "show-error": __props.showError,
    "is-max-width-field": __props.isMaxWidthField
  }, {
    label: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.label), 1)
    ]),
    field: _withCtx(() => [
      _createVNode(SelectFormInput, {
        modelValue: _unref(fieldModel),
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => (_isRef(fieldModel) ? (fieldModel).value = $event : null)),
          onFieldChange
        ],
        "select-id": __props.inputId,
        name: __props.name,
        "has-error": __props.showError,
        "aria-describedby": _unref(ariaDescribedby)
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, index) => {
            return (_openBlock(), _createElementBlock("option", {
              key: index,
              value: option.value
            }, _toDisplayString(option.label), 9, _hoisted_1))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "select-id", "name", "has-error", "aria-describedby"])
    ]),
    error: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.errorMessage), 1)
    ]),
    _: 1
  }, 8, ["input-id", "show-error", "is-max-width-field"]))
}
}

})